/**
 * RouteNames — Enum tên route dùng chung cho toàn bộ app Merchant UI
 * Dùng khi gọi router.push({ name: RouteName.Dashboard })
 * CreatedBy: dbhuan (2026-06-09)
 */
export const RouteName = Object.freeze({
  // Landing / Auth
  Login: "login",
  MisaId: "misaid",
  AmplCallback: "ampl-callback",
  Register: "register",
  Forgot: "forgot",
  TwoFactor: "twofactor",
  Confirm: "confirm",
  Active: "active",
  RegisterUnit: "register-unit",
  SetupSuccess: "setup-success",

  // Main
  Home: "/",
  Dashboard: "dashboard",
  DashboardOfficial: "dashboardOfficial",

  // Transactions
  Transactions: "transactions",
  TransactionDetails: "TransactionDetails",
  TransactionDetailsToken: "TransactionDetailsToken",

  // Control
  ReportControl: "reportcontrol",
  ControlReportDetail: "controlReportDetail",

  // Refund
  Refund: "refund",
  RefundDetails: "RefundDetails",

  // Payment Link
  PaymentLinkList: "paymentlinklist",
  PaymentLinkCreate: "paymentlinkcreate",
  PaymentLinkOrder: "paymentlinkorder",

  // Profile
  ProfileInfo: "ProfileInfo",
  ProfileUpdateRequest: "ProfileUpdateRequest",

  // Settings
  SettingLogo: "setting-logo",
  SettingService: "setting-service",
  SettingWordpress: "setting-wordpress",
  InfoControl: "info-control",

  // User & Employee
  User: "user",
  Employee: "employee",
  SubAccount: "subaccount",
  Role: "role",
  Customer: "customer",

  // Others
  AuditingLog: "auditinglog",
  Audit: "audit",
  Contacts: "contacts",
  ImportPage: "import-page",
  CollectionPeriod: "collection-period",
  HistoryPrivacyPolicy: "history-privacypolicy",
  GettingStarted: "gettingstarted",

  // Error pages
  NotFound: "NotFound",
  Error403: "403",
  Error500: "500",
  ExpiredLicense: "ExpiredLicense",
  SyncResource: "SyncResource",

  // Payment
  PaymentRequests: "paymentrequests",
  Success: "success",
  Cancel: "cancel",

  // Others
  Test: "test",
  FilePreview: "FilePreview",
  EmbedAgreement: "embed-agreement",
  EmbedAgreementSession: "embed-agreement-session",
  JPAgreementSdkTest: "jp-agreement-sdk-test",
  Memas: "memas",
  DangKy: "dangky",
  Demo: "demo",
  Demo2: "demo2",
  Demo3: "demo3",
  Demo4: "demo4",
  EmailConfirm: "emailconfirm",
  PaymentBillDetails: "paymentbilldetails",
  PaymentShopDetail: "paymentshopdetail",
  PaymentWebsiteDetail: "paymentwebsitedetail",
});
